<template>
  <svg viewBox="5 5 40 40">
    <path
      style="display: inline; fill: #010203"
      d="M40.38,26.97l-7.74,2.02l-6.45-3.78l6.45-3.78l7.74,2.02
	c0.04,0.01,0.08,0.02,0.13,0.02c0.22,0,0.42-0.15,0.48-0.37c0.07-0.27-0.09-0.54-0.36-0.61l-6.77-1.76l6.5-3.81
	c0.24-0.14,0.32-0.45,0.18-0.68c-0.14-0.24-0.45-0.32-0.68-0.18l-6.5,3.81l1.77-6.77c0.07-0.27-0.09-0.54-0.36-0.61
	c-0.27-0.07-0.54,0.09-0.61,0.36l-2.03,7.74l-6.44,3.77v-7.46l5.65-5.66c0.19-0.2,0.19-0.51,0-0.71c-0.19-0.19-0.51-0.2-0.71,0
	l-4.94,4.95V7.92c0-0.28-0.22-0.5-0.5-0.5s-0.5,0.22-0.5,0.5v7.54l-4.94-4.95c-0.2-0.2-0.51-0.2-0.71,0c-0.2,0.2-0.2,0.51,0,0.71
	l5.65,5.66v7.46l-6.44-3.77l-2.03-7.73c-0.07-0.27-0.35-0.43-0.61-0.36c-0.27,0.07-0.43,0.34-0.36,0.61l1.77,6.77l-6.5-3.81
	c-0.24-0.14-0.54-0.06-0.68,0.18c-0.14,0.24-0.06,0.55,0.18,0.68l6.5,3.81l-6.77,1.76c-0.27,0.07-0.43,0.34-0.36,0.61
	c0.06,0.23,0.26,0.37,0.48,0.37c0.04,0,0.08-0.01,0.13-0.02l7.74-2.02l6.45,3.78l-6.45,3.78l-7.74-2.02
	c-0.26-0.07-0.54,0.09-0.61,0.36c-0.07,0.27,0.09,0.54,0.36,0.61l6.77,1.76l-6.5,3.81c-0.24,0.14-0.32,0.45-0.18,0.68
	c0.09,0.16,0.26,0.25,0.43,0.25c0.09,0,0.17-0.02,0.25-0.07l6.5-3.81l-1.77,6.77c-0.07,0.27,0.09,0.54,0.36,0.61
	c0.04,0.01,0.09,0.02,0.13,0.02c0.22,0,0.42-0.15,0.48-0.37l2.03-7.73l6.44-3.77v7.46l-5.65,5.66c-0.19,0.2-0.19,0.51,0,0.71
	c0.2,0.19,0.51,0.19,0.71,0l4.94-4.95v7.54c0,0.28,0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5v-7.54l4.94,4.95c0.1,0.1,0.23,0.15,0.35,0.15
	c0.13,0,0.26-0.05,0.35-0.15c0.2-0.2,0.2-0.51,0-0.71l-5.65-5.66v-7.46l6.44,3.77l2.03,7.74c0.06,0.23,0.26,0.37,0.48,0.37
	c0.04,0,0.08-0.01,0.13-0.02c0.27-0.07,0.43-0.34,0.36-0.61l-1.77-6.77l6.5,3.81c0.08,0.05,0.17,0.07,0.25,0.07
	c0.17,0,0.34-0.09,0.43-0.25c0.14-0.24,0.06-0.54-0.18-0.68l-6.5-3.81l6.77-1.76c0.27-0.07,0.43-0.34,0.36-0.61
	C40.92,27.06,40.65,26.9,40.38,26.97z"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconWinter extends Vue {}
</script>

<style scoped type="text/css">
.st0 {
  fill: #010203;
}
</style>
